import React from 'react'

import CircularProgress from '@mui/material/CircularProgress'
// material ui
import Typography from '@mui/material/Typography'

import styled from 'styled-components'

// theme
import aampeTheme from '../../constants/aampeTheme'

// hooks
import useDatasetByIdQuery from '../../hooks/datasets/useDatasetByIdQuery'

export default function FormulaSidebarDataset({ selectedComponent }) {
    const { data, isPending: isLoading } = useDatasetByIdQuery(
        selectedComponent.datasetId,
    )
    const datasetName = data ? data.name : ''
    const datasetField =
        data && data.fields
            ? data.fields.find(
                  (column) => column.id === selectedComponent.datasetField,
              )
            : null
    const sampleValue =
        datasetField && datasetField.sample
            ? Array.isArray(datasetField.sample)
                ? datasetField.sample[0]
                : datasetField.sample
            : null
    return (
        <Container>
            {isLoading ? (
                <div
                    style={{
                        width: '100%',
                        height: '200px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <CircularProgress />
                </div>
            ) : (
                <div style={{ margin: aampeTheme.spacing4(1), width: '100%' }}>
                    <div>
                        <SubHeaderTypography variant="h5">
                            Dataset name:
                        </SubHeaderTypography>
                        <TextTypography variant="body1">
                            {datasetName}
                        </TextTypography>
                    </div>
                    <div>
                        <SubHeaderTypography variant="h5">
                            Dataset field:
                        </SubHeaderTypography>
                        <TextTypography variant="body1">
                            {datasetField?.name}
                        </TextTypography>
                    </div>
                    <div>
                        <SubHeaderTypography variant="h5">
                            Sample value:
                        </SubHeaderTypography>
                        <TextTypography variant="body1">
                            {sampleValue}
                        </TextTypography>
                    </div>
                </div>
            )}
        </Container>
    )
}

const Container = styled.div({
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    padding: aampeTheme.spacing4(0, 2),
})

const SubHeaderTypography = styled(Typography)({
    display: 'inline-block',
    width: '150px',
    margin: aampeTheme.spacing4(1),
})

const TextTypography = styled(Typography)({
    display: 'inline-block',
})
